module.exports = __webpack_public_path__ + "img/b0fc86e.png";